var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "986px",
    height: "773px",
    viewBox: "0 0 986 773",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Inst Design") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-52.9%",
    y: "-51.5%",
    width: "205.7%",
    height: "203.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.716060915   0 0 0 0 0.716060915   0 0 0 0 0.716060915  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-52.9%",
    y: "-157.6%",
    width: "205.7%",
    height: "415.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 19,
    dy: 25,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.716060915   0 0 0 0 0.716060915   0 0 0 0 0.716060915  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-52.9%",
    y: "-157.6%",
    width: "205.7%",
    height: "415.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 19,
    dy: 25,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.716060915   0 0 0 0 0.716060915   0 0 0 0 0.716060915  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-76.2%",
    y: "-113.2%",
    width: "252.5%",
    height: "326.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.364705882   0 0 0 0 0.788235294   0 0 0 0 0.356862745  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inst-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web1",
    transform: "translate(88.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#F4F7F8",
    x: 0,
    y: 12.5858209,
    width: 752.5,
    height: 611.25,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,12.75 L147.5,12.75 C153.022847,12.75 157.5,17.2271525 157.5,22.75 L157.5,624 L157.5,624 L10,624 C4.4771525,624 6.76353751e-16,619.522847 0,614 L0,22.75 C-6.76353751e-16,17.2271525 4.4771525,12.75 10,12.75 Z",
    id: "Background",
    fill: "#494848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#DDE3E9",
    x: 22.5,
    y: 272.75,
    width: 112.5,
    height: 13.4134615,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#BEC3C7",
    x: 22.5,
    y: 299,
    width: 112.5,
    height: 13.4134615,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#A8ABAE",
    x: 22.5,
    y: 325.25,
    width: 112.5,
    height: 13.4134615,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#A8ABAE",
    x: 38.75,
    y: 572.75,
    width: 80,
    height: 13.75,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profile-Info",
    transform: "translate(22.500000, 71.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1811233,30.5914352 C48.588629,30.5914352 51.3412434,35.2999132 53.7702152,39.4543547 C57.4045909,45.6685475 61.5236052,52.5 68.2969852,52.5 C78.0404741,52.5 87.9042171,39.6600155 92.1741639,33.4192147 C92.2242557,34.1961741 92.25,34.9797153 92.25,35.7692308 C92.25,55.5240314 76.132251,71.5384615 56.25,71.5384615 C36.367749,71.5384615 20.25,55.5240314 20.25,35.7692308 C20.25,34.8045719 20.2884332,33.8488321 20.3638612,32.9034405 C21.5261485,34.692667 22.4685032,37.2472668 23.3197273,39.577474 C25.2648862,44.9032118 27.0011634,50.4543909 31.6535276,50.4543909 C36.1944333,50.4543909 38.1965599,45.0804036 40.132637,39.8836082 C41.75663,35.5278501 43.5961096,30.5914352 46.1811233,30.5914352 Z M56.25,-8.48210391e-13 C72.1520565,-8.48210391e-13 85.6459659,10.2444104 90.4113314,24.4533497 C83.9261808,37.1400625 74.2334724,48.0868417 68.2969852,48.0868417 C64.1474231,48.0868417 60.8837503,42.5040509 57.7265824,37.1051071 C54.3762197,31.3767361 51.2124468,25.9653139 46.1811233,25.9653139 C40.4149987,25.9653139 37.9818989,32.4956236 35.8344633,38.25727 C34.779322,41.0890119 33.2618339,45.8282697 31.6535276,45.8282697 C29.9213785,45.8282697 28.2040906,40.8136574 27.1373905,37.8945674 C25.6395195,33.794089 24.1099334,29.3652982 21.2798229,27.2422411 C25.1283258,11.6044814 39.3252338,-8.48210391e-13 56.25,-8.48210391e-13 Z",
    id: "Avatar-2",
    fill: "#92D39D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#DDE3E9",
    x: 0,
    y: 80.4759615,
    width: 112.5,
    height: 13.4134615,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#BCBEC0",
    x: 18,
    y: 102.826923,
    width: 76.5,
    height: 13.4134615,
    rx: 4.375
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10,0.0858208955 L742.5,0.0858208955 C748.022847,0.0858208955 752.5,4.5629734 752.5,10.0858209 L752.5,40.0858209 L752.5,40.0858209 L0,40.0858209 L0,10.0858209 C-6.76353751e-16,4.5629734 4.4771525,0.0858208955 10,0.0858208955 Z",
    id: "Header",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Buttons",
    transform: "translate(11.250000, 12.585821)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "buttons",
    fill: "#E28D8D",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "buttons",
    fill: "#BDEEA2",
    cx: 20,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "buttons",
    fill: "#F2F2F2",
    cx: 35,
    cy: 5,
    r: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Components",
    filter: "url(#filter-1)",
    transform: "translate(230.000000, 121.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 452.5,
    height: 465,
    rx: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Components",
    filter: "url(#filter-2)",
    transform: "translate(283.750000, 180.250000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 452.5,
    height: 151.25,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#D0D0D0",
    x: 25,
    y: 26.25,
    width: 112.5,
    height: 13.4134615,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#EAE8E8",
    x: 25,
    y: 52.5,
    width: 347.5,
    height: 13.75,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#EAE8E8",
    x: 25,
    y: 78.75,
    width: 347.5,
    height: 13.75,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#EAE8E8",
    x: 25,
    y: 105,
    width: 293.75,
    height: 13.75,
    rx: 4.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Components",
    filter: "url(#filter-3)",
    transform: "translate(357.500000, 389.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 452.5,
    height: 151.25,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#D0D0D0",
    x: 25,
    y: 26.25,
    width: 112.5,
    height: 13.4134615,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#EAE8E8",
    x: 25,
    y: 52.5,
    width: 347.5,
    height: 13.75,
    rx: 4.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    fill: "#EAE8E8",
    x: 25,
    y: 78.75,
    width: 286.25,
    height: 13.75,
    rx: 4.375
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(573.500000, 419.000000) scale(-1, 1) rotate(12.000000) translate(-573.500000, -419.000000) translate(512.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    filter: "url(#filter-4)",
    transform: "translate(61.500000, 55.000000) rotate(-30.000000) translate(-61.500000, -55.000000) translate(11.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8280383,54.6067275 C50.8260383,54.6117275 50.8240383,54.6167275 50.8210383,54.6227275 C50.8240383,54.6177275 50.8280383,54.5977275 50.8280383,54.6067275",
    id: "Fill-35",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8233815,54.6143262 C50.8233815,54.6153262 50.8223815,54.6173262 50.8223815,54.6193262 C50.8223815,54.6143262 50.8313815,54.5993262 50.8233815,54.6143262",
    id: "Fill-37",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8581098,54.5297294 C50.8511098,54.5497294 50.8421098,54.5687294 50.8341098,54.5887294 C50.8381098,54.5787294 50.8421098,54.5707294 50.8461098,54.5607294 C50.7421098,54.8207294 50.8081098,54.6517294 50.8581098,54.5297294",
    id: "Fill-39",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8357258,54.5899536 C50.8317258,54.5989536 50.8277258,54.6089536 50.8237258,54.6179536 C50.7947258,54.6739536 50.8357258,54.5899536 50.8357258,54.5899536",
    id: "Fill-41",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#C5CFD6",
    points: "50.8245383 54.6140786 50.8245383 54.6140786 50.8245383 54.6130786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8240383,54.6145786 C50.8240383,54.6135786 50.8240383,54.6135786 50.8250383,54.6125786 C50.8240383,54.6135786 50.8240383,54.6135786 50.8240383,54.6145786",
    id: "Fill-45",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8192941,54.621754 C50.8132941,54.633754 50.8472941,54.575754 50.8192941,54.621754",
    id: "Fill-47",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8235383,54.6145786 L50.8255383,54.6125786 C50.8245383,54.6135786 50.8245383,54.6145786 50.8235383,54.6145786",
    id: "Fill-49",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Photo-Background",
    fill: "#2B44FF",
    x: 0.574535623,
    y: 0.818446954,
    width: 100,
    height: 66,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-night_landscape",
    transform: "translate(9.057629, 20.092572)",
    fill: "#000000",
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Mountains",
    points: "29.3115079 0 0.47121868 47 58.1517972 47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Mountains",
    points: "59.0474583 12.5892857 33.5509707 47 84.543946 47"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    fill: "#FFFFFF",
    cx: 79.0165764,
    cy: 23.6424793,
    r: 9.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboard);
export default __webpack_public_path__ + "static/media/empty-dashboard.ff4097e959e6cf72524611d2c4a8a30f.svg";
export { ForwardRef as ReactComponent };